import { render } from "./CustomImageCard.vue?vue&type=template&id=5af25e94&scoped=true"
import script from "./CustomImageCard.vue?vue&type=script&lang=js"
export * from "./CustomImageCard.vue?vue&type=script&lang=js"

import "./CustomImageCard.vue?vue&type=style&index=0&id=5af25e94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af25e94"]])

export default __exports__